import { FC } from 'react'
import { RecruitListItem_CurrentUserFragment } from 'generated/graphql'
import { ACTIVITY_NOTICE_AD_CODE_ID } from '@app.feature/ad/constants/adCode'
import { TOTAL_AD_SLOTS } from '@app.feature/ad/constants/constants'
import useGetActivityListFromAdsByPlacementCode from '@app.feature/ad/hooks/useGetActivityListFromAdsByPlacementCode'
import RecruitListSkeleton from '@app.feature/recruitList/component/recruitListTable/component/RecruitListSkeleton'
import { ActivityTypeID } from 'constants/enums'
import NoticeBannerRecruitInternDesktop from './NoticeBannerRecruitIntern.desktop'

interface IFProps {
  activityType: ActivityTypeID
  currentUser?: RecruitListItem_CurrentUserFragment | null
}

export const RECRUIT_TYPE_TO_AD_CODE = {
  [ActivityTypeID.RECRUIT]: ACTIVITY_NOTICE_AD_CODE_ID.RECRUIT_NOTICE,
  [ActivityTypeID.INTERN]: ACTIVITY_NOTICE_AD_CODE_ID.INTERN_NOTICE,
}

const NoticeBannerRecruitInternStatusDesktop: FC<IFProps> = ({
  activityType,
  currentUser,
}) => {
  const { ads, loading, error } = useGetActivityListFromAdsByPlacementCode({
    adPlacementCode: RECRUIT_TYPE_TO_AD_CODE[activityType],
    activityTypeID: activityType,
  })

  if (loading) {
    return <RecruitListSkeleton skeletonCount={TOTAL_AD_SLOTS} />
  }

  if (error || !ads?.length) {
    return null
  }

  return (
    <NoticeBannerRecruitInternDesktop ads={ads} currentUser={currentUser} />
  )
}

export default NoticeBannerRecruitInternStatusDesktop
